export default __webpack_public_path__ + "static/media/cough.68780d07.png";